import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";
import { arrayOfLabels } from "./schema.labels.jsx";

const recurringTask = new schema.Entity(`recurring_tasks`);
const arrayOfRecurringTasks = [recurringTask];

recurringTask.define({
  labels: arrayOfLabels,
  attachments: arrayOfAttachments,
});

export { recurringTask, arrayOfRecurringTasks };
